import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import MenuIcon from "@material-ui/icons/Menu";
import { Box } from "@material-ui/core";
import { theme } from "../theme";

const useStyles = makeStyles(theme => ({
  root: {
    borderBottomRightRadius: 50,
    borderTopRightRadius: 50,
  },

  menu: {
    cursor: "pointer",
    fontSize: "3rem",
  },
}));

const MenuBanner = ({ open, onClick }) => {
  const classes = useStyles();

  return (
    <Slide direction={"right"} in={open}>
      <Box
        boxShadow={2}
        zIndex={1200}
        position="fixed"
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        top={theme.spacing(6)}
        left={0}
        height={56}
        width={64}
        color={theme.palette.primary.main}
        bgcolor={theme.palette.primary.contrastText}
        className={classes.root}
      >
        <MenuIcon
          fontSize="large"
          classes={{
            fontSizeLarge: classes.menu,
          }}
          onClick={onClick}
        />
      </Box>
    </Slide>
  );
};

export default MenuBanner;
